const WORDS = [
  "Design personalizado", "Desenvolvimento à medida", "SEO", "Velocidade",
  "Responsivo", "Lojas online", "Reservas", "Suporte próximo",
];

export const Marquee = ({ dark = false }) => {
  const items = [...WORDS, ...WORDS];
  return (
    <div
      className={`relative overflow-hidden border-y py-6 md:py-9 ${
        dark ? "border-white/10 bg-ink" : "border-line bg-mist"
      }`}
      data-testid="marquee"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform" style={{ animation: "marquee 38s linear infinite" }}>
        {items.map((w, i) => (
          <span key={i} className="mx-6 flex items-center gap-6">
            <span className={`font-display text-2xl font-semibold tracking-tight md:text-4xl ${dark ? "text-white/90" : "text-ink"}`}>
              {w}
            </span>
            <span className="h-2 w-2 rounded-full bg-grad" />
          </span>
        ))}
      </div>
    </div>
  );
};
